import {SellerError} from './SellerError.js'

export class ContactValidationSellerError extends SellerError {
  constructor({errors}) {
    super()
    this._errors = errors
  }

  hasErrors() {
    return Boolean(this._errors.length)
  }

  getErrors() {
    return this._errors
  }
}
